import { useClientRouteHost } from '../context/ClientRouteHostContext'
import { usePortalAuth } from './usePortalAuth'

/**
 * Hold portal user-scoped queries until hostname → clientId resolution finishes.
 * While the host is loading, clientId is still undefined, which would otherwise
 * fetch every school's data (unified-portal query) on a client subdomain.
 */
export const scopePortalUserIdUntilHostReady = (
  enrollmentUserId: string | null,
  hostLoading: boolean
): string | null => (hostLoading ? null : enrollmentUserId)

/**
 * Normal customers stay on the hostname school.
 * View-as uses the Super Admin's selected school, or every school when none was chosen.
 */
export const scopePortalClientIdForViewAs = (
  hostClientId: string | undefined,
  isViewAs: boolean,
  viewAsClientId?: string
): string | undefined => {
  if (!isViewAs) return hostClientId
  const selected = viewAsClientId?.trim()
  return selected && selected.length > 0 ? selected : undefined
}

export const usePortalHostQueryGate = (enrollmentUserId: string | null) => {
  const { isLoading: hostLoading } = useClientRouteHost()
  return {
    readyUserId: scopePortalUserIdUntilHostReady(enrollmentUserId, hostLoading),
    hostLoading
  }
}

export const usePortalQueryClientId = (): string | undefined => {
  const { isViewAs, viewAsClientId } = usePortalAuth()
  const { clientId } = useClientRouteHost()
  return scopePortalClientIdForViewAs(clientId, isViewAs, viewAsClientId ?? undefined)
}
